<script setup lang="ts">
import {PropType, Ref, ref} from "vue";
import Calendar from "@/views/Calendar/Calendar.vue";
import Modal from "@/components/Modal.vue";
import {IonButton} from "@ionic/vue";
import {kapitelDateString} from "@/graphql/kapitelTypes";

const props = defineProps({
    initialDate: {
        type: String as PropType<kapitelDateString>,
        required: false
    },
    minDate: {
        required : false,
        type: String as PropType<kapitelDateString>,
    },
    maxDate: {
        required : false,
        type: String as PropType<kapitelDateString>,
    },
    showPlanningStatus: {
        required: true,
        type: Boolean as PropType<boolean>,
    }
})

const isOpen = defineModel({type: Boolean})

const calendar : Ref<typeof Calendar|undefined>= ref(undefined)
const initCalendar = () => {calendar.value?.reinit()}

</script>

<template>
    <Modal stacking fullscreen :toolbar="false" v-model="isOpen" title="Kalender" class="no-padding-left no-padding-right no-padding-top no-padding-bottom" @view:didPresent="initCalendar">
        <Calendar
            ref="calendar"
            :initial-date="initialDate || undefined"
            :defer-init="true"
            :minDate="minDate"
            :maxDate="maxDate"
            :showPlanningStatus="showPlanningStatus"
        ></Calendar>
        <template #actions="{dismiss}">
            <ion-button
                color="light"
                expand="block"
                @click="dismiss"
                data-cy="button calendar close"
            >
                Kalender schließen
            </ion-button>
        </template>
    </Modal>
</template>
